import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TTSlotEditor.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";

import { TiClassNames, TiEntities } from "../TiTypes";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import { StringHelpers, ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";
import { GenericDialogTypes } from "../../../moreCore/UI/GenericDialog/GenericDialogTypes";
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import Button from '../../../moreCore/UI/Button/Button';
import "../../../moreCore/UI/Button/Button";
import TTSlotsCloneForm from './TTSlotsCloneForm';
const enum TiBookingType {
    "reserved" = 1,
    "booked" = 2
}

interface editorConfig {
    targetReassignDivisions: Array<TiEntities.DivisionEntity>
}

interface SlotActionData {
    action: "reassign" | "clone" | "delete" | "disable",
    slotID: string,
    data?: any
}
class TiTimeTableSlotEditor extends compose(_uiFrameMixin) {

    templateString: any = template;

    private sectionView: HTMLElement;
    private sectionControl: HTMLElement;

    private btnReassign: MdsLax<InstanceType<typeof Button>>;
    private btnClone: MdsLax<InstanceType<typeof Button>>;
    private btnDisable: MdsLax<InstanceType<typeof Button>>;

    private editorConfig: editorConfig;
    private entityID: string;
    private entityData: TiEntities.TimeTableSlotEntity;

    private _view: MdsLax<InstanceType<typeof GenericEntityView>>;

    setup(slotID: string, label: string, editorConfig: editorConfig) {

        this.entityID = slotID;

        if (this._view) {
            this._view.destroy();
            this.UiModder.domConstruct.empty(this.sectionView);
        }
        this._view = new GenericEntityView();
        this._view.placeAt(this.sectionView);

        if (editorConfig) this.editorConfig = editorConfig;

        if (!label) label = TranslationHelpers.tryTranslate("TiTimeTableSlotsPanel_Label__TimeTableSlot");


        //window.webPrivilegeManager.hasUserRole("Ti_TimeTableSlots_Admin", lang.hitch(this, this._onPrivilegesAvailable));

        if (this.isActive) {
            this._loadEntityData();
        }

        this._view.setup(slotID, TiClassNames.timetable_timeslot, label, "displayname", this.sectionView, null, "slotmanagement");

    }

    onShow() {
        if (!this.entityData && this.entityID) {
            this._loadEntityData();
        }
    }

    onClose() {
        this.emit("close");
    }



    private _loadEntityData() {
        if (!this.entityID) {
            return;
        }

        this._view.reload();

        this.StandbyStart(this.sectionControl);

        let data = {
            slotID: this.entityID
        };

        this.RequestManager.callfunction(
            "Webtool_API_TiTimeTableSlotsEditor__LoadSlotEntity",
            data,
            lang.hitch(this, this._onLoadEntityDataResult),
            lang.hitch(this, this._onLoadEntityDataError),
        );
    }

    private _onLoadEntityDataResult(data: { entity: TiEntities.TimeTableSlotEntity, label: string, availableActions: Array<string> }) {
        this.entityData = data.entity;

        this._setupControls(data.availableActions);

        this.setTitles(data.label);

        this.StandbyStop();
    }
    private _onLoadEntityDataError(error: more.requestErrorMessage) {

        this.StandbyStop();
        alert(error.Message);
    }


    private _setupControls(availableActions: Array<string>) {

        for (let action of availableActions) {

            switch (action) {

                case "reassign":

                    if (this.editorConfig) {
                        if (this.editorConfig.targetReassignDivisions?.length >= 2) {
                            this.btnReassign.show();
                        }
                    }
                    break;

                case "clone":
                    this.btnClone.show();
                    break;

                case "disable":
                    this.btnDisable.show();
                    break;

            }
        }
       
    }

   
    private _onClick_DisableSlot(evt: MouseEvent) {

        let requestData: SlotActionData = {
            action: "disable",
            slotID: this.entityID
        };

        let dlg = new GenericDialog();
        
        dlg.setup({
            header: "TiTimeTableSlotsEditor_MessageHeader__DisableSlot",
            content: StringHelpers.stringFormat("TiTimeTableSlotsEditor_Message__DisableSlot", this.title),
            buttonPreset: "yesno",
            size: "smaller",
            contentIconClass: toasterIcons.warning,
            callback: lang.hitch(this, this._requestSlotAction, requestData),
            distinctiveNoCallback: lang.hitch(this, function () { })
        });
    }
   
    private _onClick_CloneSlot(evt: MouseEvent) {
        let menu = new FloatingMenu();

            //menu.addEntry({
            //    callback: lang.hitch(this, this._onSelect_CloneSlot, "copy"),
            //    label: "TiTimeTableSlotsEditor_CloneMode__Copy"
            //});

            //menu.addEntry({
            //    callback: lang.hitch(this, this._onSelect_CloneSlot, "copyChangeTime"),
            //    label: "TiTimeTableSlotsEditor_CloneMode__CopyChangeTime"
            //});

            menu.addEntry({
                callback: lang.hitch(this, this._onSelect_CloneSlot, "copyWithRoute"),
                label: "TiTimeTableSlotsEditor_CloneMode__CopyWithRoute"
            });
            menu.addEntry({
                callback: lang.hitch(this, this._onSelect_CloneSlot, "copyChangeTimeWithRoute"),
                label: "TiTimeTableSlotsEditor_CloneMode__CopyChangeTimeWithRoute",
                icon: "fas fa-clock"
            });

        menu.open(evt, null, "TiTimeTableSlotsEditor_Btn__Clone");
    }

    private _onSelect_CloneSlot(mode: string) {

        switch (mode) {
            case "copy":
            case "copyWithRoute":
                this._onConfirm_CloneSlot(mode, {});
                break;

            case "copyChangeTimeWithRoute":
                let cloneForm = new TTSlotsCloneForm();
                cloneForm.setup(this.entityData, lang.hitch(this, this._onCloneFormResult, mode));
                cloneForm.show("smallerDlg", "TiTimeTableSlotsEditor_CloneMode__CopyChangeTimeWithRoute");

                break;

        //    case "copyChangeTime":
        //        let cloneForm = new TTSlotsCloneForm();
        //        cloneForm.setup(this.entityData, lang.hitch(this, this._onCloneFormResult, mode));
        //        cloneForm.show("smallerDlg", "TiTimeTableSlotsEditor_CloneMode__CopyChangeTime");
                
        //        break;
        }
    }

    private _onCloneFormResult(mode: string, result: any) {
        if (result) {
            this._onConfirm_CloneSlot(mode, result);
        }
    }

    private _onConfirm_CloneSlot(mode: string, data?: any) {
        data.mode = mode;

        let requestData: SlotActionData = {
            slotID: this.entityID,
            data: data,
            action: "clone"
        };

        this._requestSlotAction(requestData);
        
    }
    
    private _onClick_ReassignSlot(evt: MouseEvent) {
        let menu = new FloatingMenu();
        
        for (let div of this.editorConfig.targetReassignDivisions) {
            menu.addEntry({
                callback: lang.hitch(this, this._onSelect_ReassignSlot, div),
                label: div.name_address,
                enabled: div.ID != this.entityData.ref_division.ID,
                icon: div.ID == this.entityData.ref_division.ID ? "fas fa-check" : null
            });
        }

        menu.open(evt, null, "TiTimeTableSlotsEditor_Btn__ReassignDivision");
    }

    private _onSelect_ReassignSlot(division: TiEntities.DivisionEntity) {

        if (!division) return;

        let dlg = new GenericDialog();
        dlg.setup({
            header: "TiTimeTableSlotsEditor_MessageHeader__ReassignDivision",
            content: StringHelpers.stringFormat("TiTimeTableSlotsEditor_Message__ReassignDivision", division.name_address),
            buttonPreset: "yesno",
            size: "smaller",
            contentIconClass: "fas fa-reply fa-flip-vertical fa-flip-horizontal",
            callback: lang.hitch(this, this._onConfirm_ReassignSlot, division)
        });
    }
    private _onConfirm_ReassignSlot(division: TiEntities.DivisionEntity, result: GenericDialogTypes.GenericDialogResult) {
        if (result == GenericDialogTypes.GenericDialogResult.yes) {
            let data: SlotActionData = {
                slotID: this.entityID,
                data: {
                    targetDivisionID: division.ID
                },
                action: "reassign"
            };
            this._requestSlotAction(data);
        }

        
    }

    private _requestSlotAction(data: SlotActionData) {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_TiTimeTableSlotsEditor__SlotAction",
            data,
            lang.hitch(this, this._onSlotActionResponse),
            lang.hitch(this, this._onSlotActionError),
            true
        );
    }

    private _onSlotActionResponse(response: { success: boolean, action: string, message?: string }) {
        this.StandbyStop();
        if (!response.success) {
            if (response.message) {
                let dlg = new GenericDialog();
                dlg.setup({
                    content: response.message,
                    contentIconClass: toasterIcons.error,
                    size: "smaller",
                    header: "TiTimeTableSlotsEditor_MessageHeader__SlotActionFailed"
                });
            }
        }
        else {
            if (response.message) {
                ToasterHelpers.showToast(response.message);
            }

            switch (response.action) {
                
                case "clone":
                    this.emit("change");
                    this.close();
                    break;
                case "reassign":
                default:
                    this.emit("change");
                    this._loadEntityData();
                    break;
            }
        }
    }

    private _onSlotActionError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }


    // --------------------own methods ----------------------------end

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";


    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(TiTimeTableSlotEditor);
